import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appSelect]',
  standalone: false
})
export class SelectDirective implements OnInit, OnChanges {
  @Input() appSelect: '' | 'default' = 'default';
  @Input() noIcon = false;
  @Input() border = false;
  @Input() hasError = false;

  private previousClasses: string[] = [];

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.updateClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appSelect'] || changes['noIcon'] || changes['border'] || changes['hasError']) {
      this.updateClasses();
    }
  }

  private updateClasses(): void {
    // Remove previous classes
    this.previousClasses.forEach((cls) => {
      this.renderer.removeClass(this.el.nativeElement, cls);
    });

    // Calculate new classes
    const classes = this.getClasses();

    // Add new classes
    classes.forEach((cls) => {
      this.renderer.addClass(this.el.nativeElement, cls);
    });

    // Store for next update
    this.previousClasses = classes;
  }

  private getClasses(): string[] {
    const classes: string[] = ['select-box'];

    if (this.noIcon) {
      classes.push('select-box--no-icon');
    }

    if (this.border) {
      classes.push('select-box--border');
    }

    if (this.hasError) {
      classes.push('error-box');
    }

    return classes;
  }
}
